function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ListingFieldEditTemplate = require('./listing-field-edit.template');
var EXCLUDED_WEB3_TICKERS = new Set(['ERC-SAITO', 'BEP-SAITO']);
function returnStoreWeb3Tickers(app) {
  var _app$modules, _app$modules$returnMo;
  var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SAITO';
  var tickers = ['SAITO'];
  var buysaito = app === null || app === void 0 || (_app$modules = app.modules) === null || _app$modules === void 0 || (_app$modules$returnMo = _app$modules.returnModule) === null || _app$modules$returnMo === void 0 ? void 0 : _app$modules$returnMo.call(_app$modules, 'BuySaito');
  var currencies = Array.isArray(buysaito === null || buysaito === void 0 ? void 0 : buysaito.available_currencies) ? buysaito.available_currencies : [];
  var _iterator = _createForOfIteratorHelper(currencies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var currency = _step.value;
      var ticker = String((currency === null || currency === void 0 ? void 0 : currency.ticker) || '').trim().toUpperCase();
      if (!ticker || ticker === 'SAITO' || EXCLUDED_WEB3_TICKERS.has(ticker)) {
        continue;
      }
      if (!tickers.includes(ticker)) {
        tickers.push(ticker);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var selected = String(current || '').trim().toUpperCase();
  if (selected && !tickers.includes(selected)) {
    tickers.push(selected);
  }
  return tickers;
}
function storeWeb3TickersAnswered(app) {
  var _app$modules2, _app$modules2$returnM;
  if (requestStoreWeb3Tickers.resolved) {
    return true;
  }
  var buysaito = app === null || app === void 0 || (_app$modules2 = app.modules) === null || _app$modules2 === void 0 || (_app$modules2$returnM = _app$modules2.returnModule) === null || _app$modules2$returnM === void 0 ? void 0 : _app$modules2$returnM.call(_app$modules2, 'BuySaito');
  var currencies = buysaito === null || buysaito === void 0 ? void 0 : buysaito.available_currencies;
  // null is only assigned when a reply arrives without a currency list.
  // [] is also the value before any reply, so it does not count as an answer.
  if (currencies === null) {
    requestStoreWeb3Tickers.resolved = true;
    return true;
  }
  if (Array.isArray(currencies) && currencies.length) {
    requestStoreWeb3Tickers.resolved = true;
    return true;
  }
  return false;
}
function rememberStoreWeb3TickerResponse(app) {
  var _app$connection;
  if (requestStoreWeb3Tickers.listening || !(app !== null && app !== void 0 && (_app$connection = app.connection) !== null && _app$connection !== void 0 && _app$connection.on)) {
    return;
  }
  requestStoreWeb3Tickers.listening = true;
  app.connection.on('saito-purchase-cryptos', function () {
    requestStoreWeb3Tickers.resolved = true;
    requestStoreWeb3Tickers.pending = false;
  });
}
function requestStoreWeb3Tickers(app) {
  var _app$modules3, _app$modules3$returnM;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$force = _ref.force,
    force = _ref$force === void 0 ? false : _ref$force;
  var buysaito = app === null || app === void 0 || (_app$modules3 = app.modules) === null || _app$modules3 === void 0 || (_app$modules3$returnM = _app$modules3.returnModule) === null || _app$modules3$returnM === void 0 ? void 0 : _app$modules3$returnM.call(_app$modules3, 'BuySaito');
  if (!(buysaito !== null && buysaito !== void 0 && buysaito.authorized_public_key)) {
    return;
  }
  rememberStoreWeb3TickerResponse(app);
  if (force) {
    requestStoreWeb3Tickers.resolved = false;
    requestStoreWeb3Tickers.pending = false;
  } else if (storeWeb3TickersAnswered(app) || requestStoreWeb3Tickers.pending) {
    return;
  }
  requestStoreWeb3Tickers.pending = true;
  app.connection.emit('relay-send-message', {
    recipient: buysaito.authorized_public_key,
    request: 'buysaito available currencies',
    data: null
  });
}
requestStoreWeb3Tickers.resolved = false;
requestStoreWeb3Tickers.pending = false;
requestStoreWeb3Tickers.listening = false;
requestStoreWeb3Tickers.reset = function () {
  requestStoreWeb3Tickers.resolved = false;
  requestStoreWeb3Tickers.pending = false;
  requestStoreWeb3Tickers.listening = false;
};
var ListingFieldEdit = /*#__PURE__*/function () {
  function ListingFieldEdit(app, mod) {
    var _this = this;
    _classCallCheck(this, ListingFieldEdit);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.onSave = null;
    this.app.connection.on('saito-purchase-cryptos', function () {
      _this.refreshTickerSelect();
    });
  }
  return _createClass(ListingFieldEdit, [{
    key: "refreshTickerSelect",
    value: function refreshTickerSelect() {
      var select = document.getElementById('saito-overlay-form-ticker');
      if (!select) {
        return;
      }
      // Temporary: price edits only offer SAITO until web3 checkout is enabled again.
      select.innerHTML = '<option value="SAITO" selected>SAITO</option>';
    }

    /**
     * @param {object} options
     * @param {string} options.title
     * @param {string} options.value
     * @param {boolean} [options.multiline]
     * @param {string} [options.inputType]
     * @param {string} [options.placeholder]
     * @param {(value: string) => void|boolean} options.onSave - return false to keep overlay open
     */
  }, {
    key: "render",
    value: function render() {
      var _options$value;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.onSave = options.onSave || null;
      this.overlay.show(ListingFieldEditTemplate({
        title: options.title || 'Edit',
        value: (_options$value = options.value) !== null && _options$value !== void 0 ? _options$value : '',
        multiline: !!options.multiline,
        inputType: options.inputType || 'text',
        placeholder: options.placeholder || '',
        tickers: Array.isArray(options.tickers) ? ['SAITO'] : options.tickers || null,
        ticker: Array.isArray(options.tickers) ? 'SAITO' : options.ticker || 'SAITO'
      }));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _form$querySelector,
        _this2 = this,
        _form$querySelector2;
      var form = document.querySelector('.store-listing-field-edit');
      var input = document.getElementById('saito-overlay-form-input');
      if (!form || !input) {
        return;
      }
      input.focus();
      if (typeof input.select === 'function') {
        input.select();
      }
      (_form$querySelector = form.querySelector('[data-action="cancel"]')) === null || _form$querySelector === void 0 || _form$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.overlay.close();
      });
      (_form$querySelector2 = form.querySelector('.saito-overlay-form-submit')) === null || _form$querySelector2 === void 0 || _form$querySelector2.addEventListener('click', function (e) {
        var _input$value, _form$querySelector3;
        e.preventDefault();
        var value = (_input$value = input.value) !== null && _input$value !== void 0 ? _input$value : '';
        var ticker = ((_form$querySelector3 = form.querySelector('[data-field="ticker"]')) === null || _form$querySelector3 === void 0 ? void 0 : _form$querySelector3.value) || '';
        if (typeof _this2.onSave === 'function') {
          var ok = _this2.onSave(value, ticker);
          if (ok === false) {
            return;
          }
        }
        _this2.overlay.close();
      });
      form.addEventListener('submit', function (e) {
        var _form$querySelector4;
        e.preventDefault();
        (_form$querySelector4 = form.querySelector('.saito-overlay-form-submit')) === null || _form$querySelector4 === void 0 || _form$querySelector4.click();
      });
    }
  }]);
}();
module.exports = ListingFieldEdit;
module.exports.returnStoreWeb3Tickers = returnStoreWeb3Tickers;
module.exports.requestStoreWeb3Tickers = requestStoreWeb3Tickers;
module.exports.storeWeb3TickersAnswered = storeWeb3TickersAnswered;